export enum BidReplyActionEnum {
  AcceptBid,
  RejectBid,
  CounterBid
}
